/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */

import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { errorMessage, successMessage } from './message';

/* ==============================================================
   Main API(Rally)
   ============================================================= */

const api = {
  deariEnv: 'dev',

  async mainLoad() {
    try {
      const res = await axios.get(`${API_BASE_URL}/v1/rally`, {
        params: { rallyType: 'H' },
      });
      return res.data.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  // 조선닷컴 회원 인증 api 호출
  async memberCheck(seq, name, password) {
    try {
      await axios.post(`${API_BASE_URL}/v1/arc/profile`, {
        rally_seq: seq,
        userName: name,
        credentials: password,
      });
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  // 무료 코드 api 호출
  async freeCheck(value) {
    try {
      const res = await axios.get(`${API_BASE_URL}/v1/check/free-code`, {
        params: { freeCode: value },
        validateStatus(status) {
          // HTTP 상태 코드 200만 성공으로 간주
          return status === 200;
        },
      });
      // 서버가 응답 본문 내에서 실패 여부를 알려주는 경우 처리
      if (res.data.status && res.data.status === 404) {
        return false;
      }

      // 성공 조건 확인 (필요시 더 명확한 성공 판단 추가)
      return true;
    } catch (err) {
      console.error('freeCheck error:', err);
      return false;
    }
  },

  // 참가신청 중복체크
  async duplicateMemberCheck(seq, name, birth, email) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
      });
      const { duplicateYn } = res.data.data;

      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(errorMessage.duplicate);
      return false;
    }
  },

  // 추가모집 중복신청
  async duplicateMemberCheckAdd(seq, name, birth, email, type) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/add/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
        receiveType: type,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 400) alert(err.response.data.data);
      return false;
    }
  },

  // 추가모집 중복신청
  async duplicateMemberCheckPick(seq, name, birth) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/membership/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return res;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 400) alert(err.response.data.data);
      return false;
    }
  },

  // 개인 참가 신청 api 호출
  async applyMember(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/v1/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 얼리버드 참가자 신청
  async earlyMember(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/v1/earlybird/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 추가모집 신청
  async applyMemberAdd(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/v1/add/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 참가신청 조회 api 호출
  async infoMember(seq, name, birth, password) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/apply/info/member`, {
        rallySeq: seq,
        name,
        birth,
        password,
      });
      return res;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 404) alert(errorMessage.confirm.empty);
      if (err.response?.status === 400) alert(errorMessage.confirm.fix);
      return false;
    }
  },

  // 독자인증 체크
  async checkSubscription(jsonData) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/check/subscription`, jsonData);

      if (res.data.data.subsYn === 'N') {
        alert(errorMessage.auth.email.error);
        return false;
      // eslint-disable-next-line no-else-return
      } else {
        alert(successMessage.auth.auth);
        return res.data;
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 409) alert(errorMessage.auth.email.subsDuplicate);
      if (err.response?.status === 404) alert(errorMessage.auth.impossible);
      return false;
    }
  },

  // 비밀번호 찾기
  async searchPasswordApi(seq, name, birth) {
    try {
      await axios.post(`${`${API_BASE_URL}/v1/find-password`}`, {
        rallySeq: seq,
        name,
        birth,
      });
      alert(successMessage.password);
      return true;
    } catch (err) {
      console.log(err);

      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.auth.password); }

      return false;
    }
  },

  // 개인 정보 수정
  async changepartInfo(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/v1/modify/member`, jsonData);
      alert(successMessage.confirm);
      location.href = '../index.html';
      return true;
    } catch (err) {
      console.log(err);
      if (err.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 페이스메이커 신청 api 호출
  partFacemaker(jsonData) {
    axios.post(`${API_BASE_URL}/v1/apply/pace-maker`, jsonData)
    .then(() => {
      alert('페이스메이커 신청이 완료 되었습니다. 신청정보 수정은 사무국으로 문의 바랍니다.');
      location.href = '../index.html';
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 409) { alert('이미 신청한 이력이 있습니다.'); }
      if (err.response?.status === 400) alert(err.response.data.data);
    });
  },

  // 대회 기록(개인별)
  indRecord() {
    axios.post(`${API_BASE_URL}/v1/record/current`, {
      type: 'personal',
      year: '2024',
      name: document.getElementById('name').value,
      birth: document.getElementById('birth').value,
    })
    .then(() => {
      recordIndObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) {
        alert('Server Error');
      }
      if (err.status === 404) {
        alert('조회 결과가 없습니다.');
      }
    });
  },

  // 대회 기록(부문별)
  partIndRecord(inputArr) {
    axios.post(`${API_BASE_URL}/v1/record/current`, {
      type: 'year',
      code: inputArr[0],
      year: '2024',
      gender: inputArr[1],
      age: inputArr[2],
      page: inputArr[3],
    })
    .then(() => {
      recordIndPartObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 404) { alert('조회 결과가 없습니다.'); }
    });
  },

  // 역대 기록(개인별)
  allTimeRecord(name, tel) {
    axios.post(`${API_BASE_URL}/v1/record/history`, {
      type: 'personal',
      name,
      tel,
    })
    .then(() => {
      console.log(res);
      recordAllObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }
    });
  },

  // 역대 기록(부문별)
  partTimeRecord(inputArr) {
    axios.post(`${API_BASE_URL}/v1/record/history`, {
      type: 'year',
      code: inputArr[0],
      year: inputArr[1],
      gender: inputArr[2],
      page: inputArr[3],
    })
    .then(() => {
      console.log(res);
      recordPartObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }

      alert(errorMessage.record.error);
    });
  },

  hofList(inputArr) {
    axios.post(`${API_BASE_URL}/v1/hof/list`, {
      gender: inputArr[0],
      recordCnt: inputArr[1],
      bestRecord: inputArr[2],
      type: inputArr[3],
      value: inputArr[4],
      page: inputArr[5],
    })
    .then(() => {
      console.log(res);
      hofListObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 404) { alert('조회 결과가 없습니다.'); }

      alert('기록 조회에 실패했습니다.');
    });
  },

  hofListIndividual(value) {
    axios.post(`${API_BASE_URL}/v1/hof/detail`, {
      no: value,
    })
    .then(() => {
      console.log(res);
      hofIndObj = res;
    })
    .catch((err) => {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 404) { alert('조회 결과가 없습니다.'); }

      alert('기록 조회에 실패했습니다.');
    });
  },

  async setSaveOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return 'error';
    }
  },

  async setEarlyOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/earlybird/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return 'error';
    }
  },

  async setSaveOrderAdd(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/add/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return false;
    }
  },

  async setSaveOrderPick(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/membership/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return false;
    }
  },

  setWebOrder(oid) {
    axios.get(`${API_BASE_URL}/v1/request/order-form`, { params: { oid } })
    .then((resolve) => {
      const { data: info } = resolve;
      const { status, data } = info;
      if (status === 200) {
        const existingForm = document.querySelector('#payForm');
        if (existingForm) {
          existingForm.remove();
        }

        const form = document.createElement('form');
        form.method = 'post';
        form.acceptCharset = 'UTF-8';
        form.hidden = true;
        form.id = 'payForm';

        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.querySelector('#payment-page').appendChild(form);
        INIStdPay.pay('payForm');
      } else {
        alert('요청 실패');
      }
    });
  },

  async setApplyCancel(jsonObject) {
    try {
      await axios.post(`${API_BASE_URL}/v1/cancel/member`, jsonObject);
      alert('환불 및 참가 신청이 취소되었습니다.');
      location.href = '../index.html';
      return true;
    } catch (err) {
      alert(err.response.data.data);
      document.getElementById('refund_btn').disabled = false;
      return false;
    }
  },

  // 모바일 결제 창 호출
  async mobileOrder() {
    let oid = '';
    oid = await saveMobileOrder();
    if (oid !== 'error') {
      $('#payment_popup').prop('href', `${url}/mobile-open?oid=${oid}`);
      document.getElementById('payment_popup').click();
      // window.open(url + "/mobile-open?oid=" + oid, "결제창");
      }
      // window.open(url + "/mobile-open?oid=" + oid, "결제창");
  },

  async setSaveMobileOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  async setEarlyMobileOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/earlybird/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  async getPointData(uuid) {
    const baseUrl = 'www.seoulhalfmarathon.com';
    const hostUrl = window.location.hostname === baseUrl ? 'membership' : 'membership-dev';

    try {
      const res = await axios.post(`https://api-gateway.chosun.com/${hostUrl}/point/v1/check-point/${uuid}`);
      return res;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  async setSaveMobileOrderAdd(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/add/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  async setSaveMobileOrderPick(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/v1/membership/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return 'error';
    }
  },
};

export default api;
